import CityManagementPage from "./shared/CityManagementPage";
import { cityConfigs } from "./shared/cityConfig";

export default function London() {
  return <CityManagementPage config={cityConfigs.london} />;
}